module.exports = __webpack_public_path__ + "img/likedebanner.247bf1e7.png";